import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, delay, of, switchMap, throwError } from 'rxjs';
import { CookieService } from '../../Global/Cookies/cookie.service';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  // private Urls_Not_Use: string[] = ['http://localhost:4202/'];

  private CookieService = inject(CookieService);
  private router = inject(Router);

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    let req = request;

    const Token: string = localStorage.getItem('token') || "";

    if (Token) {

      req = request.clone({
        setHeaders: {
          authorization: `Bearer ${Token}`
        }
      })
    }

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {

        if (err.status === 401) {

          const Token: string = localStorage.getItem('token') || "";

          if (Token) {

            req = request.clone({
              setHeaders: {
                authorization: `Bearer ${Token}`
              }
            })
          }

          // Espera 2 segundos antes de reintentar la solicitud
          return of(null).pipe(
            delay(2000), // Retraso de 2 segundos
            switchMap(() => next.handle(req)), // Reintenta la solicitud
            catchError((retryErr: HttpErrorResponse) => {
              if (retryErr.status === 401) {
                this.CookieService.deleteCookie('Token_COMPAS');
                this.CookieService.deleteCookie('Data_User_COMPAS');
                localStorage.clear();
                this.router.navigate(['/LoginCDMS/Home'])
              }
              return throwError(retryErr);
            })
          );
        }

        return throwError(err);

      })
    );
  }

}


